import Cookies from "js-cookie";

const [ip, port] = location.host.split(":");
let TokenKey = `token_${ip}_${port}`;

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
